export default class TicketCessionController {
	static $inject = [
		'$scope',
		'$state',
		'$stateParams',
		'$uibModal',
		'TicketsService',
		'PaginationService',
		'notification',
		'$translate',
		'moment',
		'ModalService'
	];

	constructor($scope, $state, $stateParams, $uibModal, TicketsService, PaginationService, notification, $translate, moment, ModalService) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.$uibModal = $uibModal;
		this.TicketsService = TicketsService;
		this.PaginationService = PaginationService;
		this.notification = notification;
		this.$translate = $translate;
		this.moment = moment;
		this.ModalService = ModalService;
		this.loading = false;
		this.unregister = [];
		this.societes = [];
		this.sites = [];
		this.idSociete = null;
		this.idSite = null;
		this.etatCession = 0;
		this.bonsLivraisonFournisseur = [];
		this.dateDebut = null;
		this.dateFin = null;
		this.isValidDate = false;
	}

	async $onInit() {
		//Enum etatCession = A_VALIDER, VALIDER, REFUSER
		this.etatsCession = [
			{ id: 0, label: 'A valider' },
			{ id: 1, label: 'Validé' },
			{ id: 2, label: 'Refusé' }
		];
		this.etatCession = this.etatsCession[0].id;
		await this.loadSocietes();
		if (this.idSociete) {
			await this.loadSites();
		}
	}

	async loadSocietes() {
		try {
			this.societes = await this.TicketsService.getSocietesCom();
			this.idSociete = this.societes[0].id;
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async loadSites() {
		try {
			this.sites = await this.TicketsService.getSitesCom(this.idSociete);
			this.idSite = this.sites[0].id;
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async loadBonLivraisons() {
		this.changeDate();
		if (!this.isValidDate) {
			return;
		}
		this.startLoading();
		try {
			this.bonsLivraisonFournisseur = await this.TicketsService.getTicketsCession(this.idSite, this.dateDebut, this.dateFin, this.etatCession);
			this.bonsLivraisonFournisseur.forEach((bl) => {
				bl.idSiteClient = this.idSite;
				bl.selected = false;
			});
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	changeDate() {
		if (this.dateDebut && this.dateFin) {
			const dateDebutFormated = this.moment(this.dateDebut, 'DD/MM/YYYY');
			const dateFinFormated = this.moment(this.dateFin, 'DD/MM/YYYY');
			// Check if the end date is before the start date
			if (this.moment(dateFinFormated).isBefore(dateDebutFormated)) {
				this.notification.error('La date de fin doit être supérieure à la date de début');
				this.isValidDate = false;
				return;
			}
		} else {
			this.isValidDate = false;
			return;
		}
		this.isValidDate = true;
	}

	handleSelectBL(ticket) {
		ticket.selected = !ticket.selected;
	}

	isChangedBonLivraisonList() {
		return this.bonsLivraisonFournisseur.some((bl) => bl.selected);
	}

	async updateBonLivraisonFournisseur(ticket) {
		this.startLoading();
		try {
			await this.TicketsService.updateBonLivraisonFournisseur(ticket);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	openModalValiderRefuserBl(isValider) {
		const _this = this;

		const modalInstance = this.$uibModal.open({
			animation: true,
			size: 'md',
			backdrop: false,
			windowClass: 'modern-modal',
			template: `                
                <div class="modal-header modal-info mas-column mas-p-10" style="gap: 5px">
                    <div class="mas-col-fit">
                        <button type="button" class="close" aria-label="Close" ng-click="$ctrl.close()">
                            <span style="color: white" aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title"><span translate="TICKETS.CESSION_INTERNE"></span></h4>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="mas-col-fill">                     
                        <span>{{$ctrl.cessionAlert}}</span>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="mas-col-fit">
                        <div class="mas-row mas-jc-fend">
                            <div class="mas-col-fit">
                                <button class="btn btn-primary" type="button" ng-click="$ctrl.close()">
                                    <span class="hidden-xs" translate="NON"></span>
                                </button>
                                <button class="btn btn-primary" type="button" ng-click="$ctrl.validate()">
                                    <span translate="OUI"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>`,
			controllerAs: '$ctrl',
			controller: [
				'$uibModalInstance',
				function ($uibModalInstance) {
					this.cessionAlert = _this.$translate.instant(
						isValider ? 'TICKETS.CESSION_INTERNE_VALIDER_CONFIRMATION' : 'TICKETS.CESSION_INTERNE_REFUSER_CONFIRMATION',
						{
							ticketsCount: _this.bonsLivraisonFournisseur.filter((bl) => bl.selected).length
						}
					);

					this.validate = (tickets) => {
						$uibModalInstance.close(tickets);
					};
					this.close = () => $uibModalInstance.dismiss('cancel');
				}
			]
		});
		modalInstance.result.then(async function () {
			await _this.saveCession(isValider);
		});
	}

	async saveCession(isValider) {
		this.startLoading();
		try {
			const ticketsSelected = this.bonsLivraisonFournisseur.filter((bl) => bl.selected);

			await this.TicketsService.saveBLCessionInterne(ticketsSelected, isValider);
			this.notification.success(isValider ? 'TICKETS.CESSION_INTERNE_VALIDER_SUCCESS' : 'TICKETS.CESSION_INTERNE_REFUSER_SUCCESS');
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
		this.loadBonLivraisons();
	}

	goToNewBL(idBlCree) {
		let url = this.$state.href('tickets.detail', { id: idBlCree });
		window.open('gestion.html' + url);
	}

	annuler() {
		this.$state.go('tickets.list');
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}
